import { get } from "lodash";
import { useMemo } from "react";
import { useTriviaContext } from "../context-trivia";

type TriviaButtonProps = {
  text: string;
  onHandleMouse: (x: number, y: number) => void;
};

export function TriviaButton({ text, onHandleMouse }: TriviaButtonProps) {
  const { screen } = useTriviaContext();

  const backgroundColor = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorBackground"),
    [screen],
  );
  const color = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorText"),
    [screen],
  );

  return (
    <div className="flex flex-col w-1/2 pr-4 justify-center items-center">
      <button
        className="font-bold min-h-44 max-h-44 ml-4 mb-4 pt-3 rounded-3xl w-full h-full text-4xl overflow-hidden text-ellipsis"
        style={{
          backgroundColor,
          color,
        }}
        onPointerDown={(e) => onHandleMouse(e.screenX, e.screenY)}
      >
        {text}
      </button>
    </div>
  );
}
